import { makeConnectedNavbar } from "features/navbar";

import Component from "./components/DashboardNavbar";

export default makeConnectedNavbar(Component);
